import React from "react";
import { Button } from "@component/button";
import { cn } from "@util/tailwind";

interface SettingsPanelProps {
    title: string;
    description: string;
    children: React.ReactNode;
    showSaveButton?: boolean;
    onSave?: () => void;
    isLoading?: boolean;
    hasChanges?: boolean;
    /** Extra classes for the Save button (Oura merchants: a pill). Absent: the shared look. */
    saveButtonClassName?: string;
}

export default function SettingsTwoPanelLayout({
    title,
    description,
    children,
    showSaveButton = false,
    onSave,
    isLoading = false,
    hasChanges = false,
    saveButtonClassName,
}: SettingsPanelProps) {
    return (
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8">
            {/* Left Panel - Title and Description */}
            <div className="lg:col-span-1">
                <div className="space-y-2">
                    <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
                    <p className="text-sm text-gray-600">{description}</p>
                </div>
            </div>

            {/* Right Panel - Form Content */}
            <div className="lg:col-span-4">
                <div className="space-y-6">
                    {children}
                    {showSaveButton && (
                        <div className="flex justify-end pt-4">
                            <Button
                                onClick={onSave}
                                disabled={!hasChanges || isLoading}
                                className={cn("bg-blue-600 hover:bg-blue-700 text-white disabled:opacity-50 disabled:cursor-not-allowed", saveButtonClassName)}
                            >
                                Save Changes
                            </Button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
